class GroupedProductPicker extends HTMLElement {
    connectedCallback() {
        const dataElement = this.querySelector('script[type="application/json"]');
        if (!dataElement) return;
        this.data = JSON.parse(dataElement.textContent);
        this.products = this.data.products || [];
        this.state = {
            size: this.data.current?.size || ""
        };
        this.sizeLabel = this.querySelector(".js-grouped-picker-size-label");
        this.sizeButtons = Array.from(this.querySelectorAll('[data-option-type="size"]'));
        this.onClick = this.handleClick.bind(this);
        this.addEventListener("click", this.onClick);
        this.render();
    }

    disconnectedCallback() {
        this.removeEventListener("click", this.onClick);
    }

    handleClick(event) {
        const button = event.target.closest(".grouped-product-picker__option");
        if (!button || button.disabled) return;
        const targetProduct = this.getAvailableForSize(button.dataset.value);
        if (!targetProduct?.url) return;
        const targetVariant = this.getMatchingVariant(targetProduct);
        const targetUrl = targetVariant
            ? `${targetProduct.url}?variant=${targetVariant.id}`
            : targetProduct.url;
        window.location.assign(targetUrl);
    }

    getAvailableForSize(size) {
        return this.products.find((product => product.size === size && product.available)) || null;
    }

    getCurrentVariantId() {
        const formInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
        if (formInput?.value) return formInput.value;
        return new URLSearchParams(window.location.search).get("variant");
    }

    getMatchingVariant(targetProduct) {
        const currentProduct = this.products.find((product => product.isCurrent));
        const currentVariantId = this.getCurrentVariantId();
        const currentVariant = currentProduct?.variants?.find((variant => String(variant.id) === String(currentVariantId)))
            || currentProduct?.variants?.[0];
        if (!currentVariant) return null;
        const targetVariants = targetProduct.variants || [];
        return targetVariants.find((variant => variant.title === currentVariant.title && variant.available))
            || targetVariants.find((variant => variant.title === currentVariant.title))
            || null;
    }

    render() {
        if (this.sizeLabel) this.sizeLabel.textContent = this.state.size;
        this.sizeButtons.forEach((button => {
            const size = button.dataset.value;
            const isAvailable = !!this.getAvailableForSize(size);
            const isActive = size === this.state.size;
            button.classList.toggle("is-active", isActive);
            button.classList.toggle("is-disabled", !isAvailable);
            button.disabled = !isAvailable;
            button.setAttribute("aria-pressed", isActive ? "true" : "false");
        }));
    }
}

customElements.define("grouped-product-picker", GroupedProductPicker);
